import React, { useEffect, useState, useMemo, Fragment } from 'react'
import { withWindowSizeListener } from 'react-window-size-listener'
import { useHistory, useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import { FiArrowLeft, FiShoppingCart } from 'react-icons/fi'
import Slider from 'react-slick'
import text from '../../constants/Moodboard'
import menu from '../../constants/Menu'
import textShopList from '../../constants/ListCompras'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { imageBaseURL } from '../../services/defaultProps'
import '../../styles/components/Carousel.css'
import '../../styles/containers/Moodboard.css'
import useLanguage from '../../hooks/useLanguage'

function onBoxScroll (e) {
  if (e.target.scrollTop + 120 === e.target.scrollHeight) {
    e.target.nextSibling.style.opacity = 0
  } else {
    e.target.nextSibling.style.opacity = 1
  }
}

let sliderRef
const MoodboardTemplateCarouselWithoutSizeListener = ({ moodboard, windowSize, isUpload, language, hasFilters }) => {
  const { push } = useHistory()
  const location = useLocation()

  const sliderHeight = useMemo(() => windowSize.windowHeight - 75 - 16 - 20 - 15 - (hasFilters ? 56 : 0), [windowSize.windowHeight])
  const settings = useMemo(() => ({
    dots: false,
    infinite: true,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: 0,
    useTransform: true,
    arrows: false,
    className: 'imagecarousel-slider',
    afterChange: page => {
      const textBoxesHtml = document.getElementsByClassName('moodboard-imagecarousel-text')
      const textBoxes = [...textBoxesHtml]
      textBoxes.forEach(box => {
        box.scrollTo({
          top: 0
        })
      })
      setPage(page)
    }
  }), [])

  const [page, setPage] = useState((location.state && location.state.moodboardPage) || 0)
  const [initialSlide, setInitialSlide] = useState((location.state && location.state.moodboardPage) || 0)

  const renderLinkToShopListButton = slide => {
    return (slide.shopListTemplateItem && !slide.shopListTemplateItem.isDeleted) && (
      <div className='moodboard-imagecarousel-linktoshoplist'>
        <button className='moodboard-imagecarousel-button' onClick={() => {
          const category = slide.shopListTemplateItem.category

          push('/compras/visualizacao', {
            fromSeeInShopList: true,
            shopListItemId: slide.shopListTemplateItem.id,
            category: category.toLowerCase(),
            nameCategory: textShopList[category][language],
            stateToGoBack: {
              ...location.state,
              moodboardPage: page
            }
          })
        }}>
          Ver na lista de compras
          <FiShoppingCart size={16} color='white' style={{
            marginLeft: 12, position: 'relative', top: 3
          }} />
        </button>
      </div>
    )
  }

  const renderSlideAccordingType = slide => {
    if (slide.type === 'image') {
      return (
        <Fragment>
          <div className='moodboard-imagecarousel-title'>
            {slide.title}
          </div>
          <img src={imageBaseURL + slide.image} alt={slide.image}
            className='moodboard-imagecarousel-image' />
          {renderLinkToShopListButton(slide)}
        </Fragment>
      )
    }

    if (slide.type === 'imageAndText') {
      return (
        <Fragment>
          <div className='moodboard-imagecarousel-title'>
            {slide.title}
          </div>
          <img src={imageBaseURL + slide.image} alt={slide.image}
            className='moodboard-imagecarousel-image' />
          <div className='moodboard-imagecarousel-text'>
            {slide.text}
          </div>
          {renderLinkToShopListButton(slide)}
        </Fragment>
      )
    }

    if (slide.type === 'text') {
      return (
        <Fragment>
          <div className='moodboard-imagecarousel-title'>
            {slide.title}
          </div>
          <div className='moodboard-imagecarousel-texttype'>
            {slide.text}
          </div>
        </Fragment>
      )
    }

    if (slide.type === 'video') {
      return (
        <Fragment>
          <div className='moodboard-imagecarousel-title'>
            {slide.title}
          </div>
          <div className='moodboard-imagecarousel-video'>
            <iframe width='100%' height='100%' src={`https://www.youtube.com/embed/${slide.video}`} title={slide.title} frameBorder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowFullScreen />
          </div>
        </Fragment>
      )
    }

    if (slide.type === 'cover') {
      return slide.image ? (
        <img src={imageBaseURL + slide.image} alt={slide.image}
          className='moodboard-imagecarousel-image' />
      ) : (
        <div className='moodboard-imagecarousel-cover'>
          <p>{slide.name}</p>
        </div>
      )
    }

    return <div />
  }

  useEffect(() => {
    if (moodboard.length !== 0) {
      const slider = document.getElementsByClassName('imagecarousel-slider')[0]
      if (sliderHeight > 0) {
        slider.style.height = `${sliderHeight}px`
        slider.style.width = '100%'
      }
    }
  }, [windowSize.windowHeight])

  useEffect(() => {
    if (moodboard.length !== 0 && !isUpload) {
      const insertedBoxesHtml = document.getElementsByClassName('moodboard-text-seemore')
      const insertedBoxes = [...insertedBoxesHtml]
      insertedBoxes.forEach(box => {
        box.remove()
      })

      const textBoxesHtml = document.getElementsByClassName('moodboard-imagecarousel-text')
      const textBoxes = [...textBoxesHtml]
      const scrollDownAdviceElementsHtml = document.getElementsByClassName('moodboard-text-seemore')
      const scrollDownAdviceElements = [...scrollDownAdviceElementsHtml]
      textBoxes.forEach(box => {
        if (box.offsetHeight >= 120 && scrollDownAdviceElements.length === 0) {
          const advice = document.createElement('div')
          advice.className = 'moodboard-text-seemore'
          advice.innerHTML = 'Arraste para baixo para ler mais'
          box.insertAdjacentElement('afterend', advice)
          box.addEventListener('scroll', onBoxScroll)
        }
      })
    }
  }, [windowSize.windowHeight, moodboard])

  useEffect(() => {
    return () => {
      const textBoxesHtml = document.getElementsByClassName('moodboard-imagecarousel-text')
      const textBoxes = [...textBoxesHtml]
      textBoxes.forEach(box => {
        box.removeEventListener('scroll', onBoxScroll)
      })
    }
  }, [])

  useEffect(() => {
    if (location.state && location.state.moodboardPage) {
      sliderRef.slickGoTo(location.state.moodboardPage)
      setPage(location.state.moodboardPage)
    }
  }, [])

  useEffect(() => {
    if (sliderRef) {
      sliderRef.slickGoTo(initialSlide)
      setPage(initialSlide)
      setInitialSlide(0)
    }
  }, [moodboard])

  if (moodboard.length === 0) {
    if (isUpload) {
      return (
        <div className='moodboard-not-configured'>
          {text.notConfigured[language]}
        </div>
      )
    } else {
      return (
        <div className='moodboard-not-configured'>
          {text.notConfiguredCategory[language]}
        </div>
      )
    }
  }
  return (
    <div className='carousel-container'>
      <div className='imagecarousel-screen-carousel'>
        <div className='imagecarousel-slider-container'>
          <Slider
            ref={function (ref) {
              sliderRef = ref
            }} {...settings} initialSlide={initialSlide}>
            {isUpload ? moodboard.map(photo => {
              return (
                <div key={photo} className='carousel-child-element'>
                  <div style={{
                    height: sliderHeight,
                    backgroundColor: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 12
                  }}>
                    <img src={photo} alt={photo}
                      className='imagecarousel-image' />
                  </div>
                </div>
              )
            }) : moodboard.map(slide => (
              <div key={slide} className='carousel-child-element'>
                <div style={{
                  height: sliderHeight,
                  backgroundColor: 'white',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 12
                }}>
                  {renderSlideAccordingType(slide)}
                </div>
              </div>
            ))}
          </Slider>
          <button className='imagecarousel-prev' onClick={() => {
            const prevPage = (page - 1 < 0 ? moodboard.length - 1 : page - 1) % moodboard.length
            setPage(prevPage)
            sliderRef.slickPrev()
          }}>
            <FaChevronLeft color='var(--primary)' size={16} />
          </button>
          <button className='imagecarousel-next' onClick={() => {
            const nextPage = (page + 1) % moodboard.length
            setPage(nextPage)
            sliderRef.slickNext()
          }}>
            <FaChevronRight color='var(--primary)' size={16} />
          </button>
        </div>
      </div>
      <div className='moodboard-pages'>
        Página {page + 1} de {moodboard.length}
      </div>
    </div>
  )
}

const MoodboardCarousel = withWindowSizeListener(MoodboardTemplateCarouselWithoutSizeListener)

const Moodboard = props => {
  const { push } = useHistory()
  const location = useLocation()

  const language = useLanguage()
  const [selectedCategoryId, setSelectedCategoryId] = useState(location.state && location.state.categoryId)

  const categoryId = useMemo(() => location.state && location.state.categoryId, [])
  const moodboard = useMemo(() => {
    const haveReleased = category => {
      if (category.items.find(item => item.released === 1)) return true
      if (!category.subcategories || category.subcategories.length === 0) return false

      for (let subcategory of category.subcategories) {
        if (haveReleased(subcategory)) return true
      }
      return false
    }

    if (!categoryId) return props.user.moodboard

    const moodboardCategory = props.user.moodboardTemplate.find(({ id }) => id === categoryId)
    if (!moodboardCategory) return []

    let slides = []

    if (haveReleased(moodboardCategory)) {
      slides.push({
        id: moodboardCategory.id,
        type: 'cover',
        image: moodboardCategory.image,
        name: moodboardCategory.name
      })

      moodboardCategory.items.forEach(item => {
        if (item.released) slides.push(item)
      })

      moodboardCategory.subcategories.forEach(subcategory => {
        if (haveReleased(subcategory)) {
          slides.push({
            id: subcategory.id,
            type: 'cover',
            image: subcategory.image,
            name: subcategory.name
          })

          subcategory.items.forEach(subcategoryItem => {
            if (subcategoryItem.released) slides.push(subcategoryItem)
          })
        }
      })
    }

    if (selectedCategoryId === categoryId) return slides

    slides = slides.filter(slide => {
      if (slide.type === 'cover') return slide.id === selectedCategoryId
      return slide.categoryId === selectedCategoryId
    })

    return slides
  }, [selectedCategoryId])

  const categoryFilters = useMemo(() => {
    if (!categoryId) return null
    const filters = moodboard.filter(slide => slide.type === 'cover').map(({ id, name }) => ({ id, name }))
    if (filters.length < 2) return null
    filters[0].name = 'Todas'
    return filters
  }, [])

  const renderFilters = () => {
    return categoryFilters && (
      <div className='moodboard-screen-filters'>
        {categoryFilters.map(filter => (
          <div className={`moodboard-screen-filter${filter.id === selectedCategoryId ? ' selected' : ''}`}
            key={filter.id} onClick={() => {
              sliderRef && sliderRef.slickGoTo(0)
              setTimeout(() => setSelectedCategoryId(filter.id), 100)
            }}>
            {filter.name}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className='moodboard-screen-container'>
      <div className='moodboard-screen-title'>
        <FiArrowLeft onClick={() => categoryId ? push('/moodboard/categorias', { mustPushOnGoBack: true }) : push('/')}
          size={24} color='var(--primary)' className='moodboard-screen-goback' />
        <p>{(moodboard.length === 0 || !categoryId) ? menu.moodboard[language] : moodboard[0].name}</p>
      </div>
      {renderFilters()}
      <MoodboardCarousel moodboard={moodboard} hasFilters={categoryFilters}
        isUpload={!categoryId} language={language} />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, actions)(Moodboard)



// WEBPACK FOOTER //
// ./src/containers/Moodboard/Moodboard.js